import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import NavMenuItem from './NavMenuItem';

var AccountMenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(AccountMenuItem, _React$Component);

  var _super = _createSuper(AccountMenuItem);

  function AccountMenuItem() {
    var _this;

    _classCallCheck(this, AccountMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "switchAccount", function (e) {
      if (_this.props.onAccountSwitch) {
        e.preventDefault();

        _this.props.onAccountSwitch(_this.props.organization.id);
      }
    });

    return _this;
  }

  _createClass(AccountMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isActive = _this$props.isActive,
          organization = _this$props.organization,
          href = _this$props.href,
          dataQA = _this$props['data-qa'],
          LinkWrapper = _this$props.LinkWrapper;
      var name = organization.name || "Account ".concat(organization.id);
      return /*#__PURE__*/React.createElement(NavMenuItem, {
        href: href,
        isActive: isActive,
        onClick: this.switchAccount,
        "data-qa": dataQA,
        LinkWrapper: LinkWrapper
      }, name);
    }
  }]);

  return AccountMenuItem;
}(React.Component);

_defineProperty(AccountMenuItem, "propTypes", {
  isActive: PropTypes.bool,
  href: PropTypes.string,
  organization: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  onAccountSwitch: PropTypes.func,
  'data-qa': PropTypes.string,
  LinkWrapper: PropTypes.func
});

export default AccountMenuItem;